import React, { useEffect, useState } from "react";

import { Card, Col, Container, Nav, Row } from "react-bootstrap";

import "../css/categories.css";
const Categories = () => {
  return (
    <>
    <section className="mt-5 categories">
       <Container >
        <Row>
          <Col lg={3}  md={4} sm={6} className="mb-2 mb-lg-auto">
            <Card>
                <Nav.Link href="#">
                   <img src="../imgs/category/1.png" />
                   <h3>Scanner</h3>
                </Nav.Link>
            </Card>
          </Col>
          <Col md={4} lg={3} sm={6}  className="mb-2 mb-lg-auto">
            <Card>
               <Nav.Link href="#">
                  <img src="../imgs/category/2.png" />
                  <h3>Printer</h3>
               </Nav.Link>
            </Card>
          </Col>
          <Col md={4} lg={3} sm={6}  className="mb-2 mb-lg-auto">
            <Card>
               <Nav.Link href="#">
               <img src="../imgs/category/3.png" />
               <h3>Drone</h3>
               </Nav.Link>
            </Card>
          </Col>
          <Col md={4} lg={3} sm={6}  className="mb-2 mb-lg-auto">
            <Card style={{backgroundColor:'rgba(203, 28, 30, 0.1)'}}>
               <Nav.Link href="#">
               {/* <img src="../imgs/category/4.png" /> */}
               <h3 style={{color:'rgba(203, 28, 30, 1)'}}>See More</h3>
               </Nav.Link>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
     
    </>
  );
};
export default Categories;
